document.querySelectorAll( '.b-faq-list' ).forEach( ( block ) => {

	// Add events.
	const buttons = block.querySelectorAll( '.b-faq__question' );
	buttons.forEach( ( btn ) => {

		btn.addEventListener( 'click', () => toggleQuestion( btn ) );
		btn.addEventListener( 'keydown', ( event ) => {

			if ( event.key === 'Enter' || event.keyCode === 13 ) {

				toggleQuestion( btn );

			}

		} );

	} );

} );

/**
 * Toggles the selected tab and adjusts its container's height
 * @param {HTMLElement} btn - The button element that toggles the tab
 */
function toggleQuestion( btn ) {

	const questionItem = btn.closest( '.b-faq__item' );
	const answer = questionItem.querySelector( '.b-faq__answer' );

	if ( questionItem.classList.contains( 'active' ) ) {

		questionItem.classList.remove( 'active' );
		btn.setAttribute( 'aria-expanded', 'false' );

		answer.style.height = '0px';

		if ( answer.currentObserver ) {

			answer.currentObserver.disconnect();

		}

	} else {

		questionItem.classList.add( 'active' );
		btn.setAttribute( 'aria-expanded', 'true' );
		adjustContainerHeight( answer );
		observeTabChanges( answer );

	}

}


/**
 * Adjusts the height of the tab container based on its content
 * @param {HTMLElement} container - The answer content element
 */
function adjustContainerHeight( container ) {

	const children = Array.from( container.children );
	const height = children.reduce( ( total, child ) => total + child.offsetHeight, 0 );
	container.style.height = `${height}px`;

}


/**
 * Sets up a ResizeObserver for a tab element.
 *
 * @param {Element} element - The element to observe.
 */
function observeTabChanges( element ) {

	const observer = new ResizeObserver( () => {

		adjustContainerHeight( element );

	} );
	observer.observe( element );
	element.currentObserver = observer;

}